import Vue from 'vue'
import VueResource from 'vue-resource'
import QueryString from 'qs'
Vue.use(VueResource)

const API_URL = process.env.API_URL

export default {
  query (params) {
    return Vue.http.get(`${API_URL}revenues`, {params: params})
  },
  get (id) {
    return Vue.http.get(`${API_URL}revenues/${id}`)
  },
  create (data) {
    return Vue.http.post(`${API_URL}revenues`, data)
  },
  update (id, data) {
    return Vue.http.patch(`${API_URL}revenues/${id}`, data)
  },
  delete (id) {
    return Vue.http.delete(`${API_URL}revenues/${id}`)
  },
  deleteFile (id, fileId) {
    return Vue.http.delete(`${API_URL}revenues/${id}/file/${fileId}`)
  },
  generateSheet (params) {
    return new Promise((resolve, reject) => {
      let url = `${API_URL}revenues/sheet`
      if (params) {
        url = `${url}?${QueryString.stringify(params)}`
      }
      resolve(window.open(url, '_BLANK'))
    })
  },
  updatePayment (id, data) {
    return Vue.http.patch(`${API_URL}revenues/${id}/payment`, data)
  },
  deletePaymentFile (id, fileId) {
    return Vue.http.delete(`${API_URL}revenues/${id}/payment/file/${fileId}`)
  },
  statusLabel: {
    provision: 'Provisão',
    emitted: 'Emitido'
  },
  statusClass: {
    provision: 'is-purple',
    emitted: 'is-info'
  }
}



// WEBPACK FOOTER //
// ./src/services/revenue.js